// Money in minor units (spec/api-conventions.md section 19.1): the exponent of a currency code of the registry
// (`Huelency.Domain.Money.Currencies`), and the decimal text the products grid shows and parses (`12.99` = 1299 USD).
const ZERO = new Set(['NG', 'JPY', 'KRW', 'VND', 'CLP']);
const THREE = new Set(['KWD', 'BHD']);

export function exponentOf(currency: string): number {
  const c = currency.toUpperCase();
  return ZERO.has(c) ? 0 : THREE.has(c) ? 3 : 2;
}

/** 1299, USD → "12.99"; 3999, NG → "3999". Exact for any safe integer (no float arithmetic). */
export function formatMinor(amount: number | string, currency: string): string {
  const exp = exponentOf(currency);
  const raw = String(amount ?? 0);
  const negative = raw.startsWith('-');
  const digits = (negative ? raw.slice(1) : raw).replace(/^0+(?=\d)/, '') || '0';
  if (exp === 0) return (negative ? '-' : '') + digits;
  const padded = digits.padStart(exp + 1, '0');
  return `${negative ? '-' : ''}${padded.slice(0, -exp)}.${padded.slice(-exp)}`;
}

/** "12.99", USD → 1299; null when the text is not a non-negative decimal with at most the currency's digits. */
export function parseMinor(text: string, currency: string): number | null {
  const exp = exponentOf(currency);
  const s = text.trim();
  const m = /^(\d+)(?:\.(\d*))?$/.exec(s);
  if (!m) return null;
  const frac = m[2] ?? '';
  if (frac.length > exp) return null;
  const n = Number(m[1]! + frac.padEnd(exp, '0'));
  return Number.isSafeInteger(n) ? n : null;
}

export const CURRENCY_PATTERN = /^[A-Z]{2,8}$/;
